import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9xk689keb: FaireProductEntity = {
  token: "p_m9xk689keb",
  type: "product",
  name: "Exotic Starbucks Dragon",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/c9a6ed7f8bcb7585d8087f2382b9741c23e39f018ec50729de995a9a17db3b7a.png",
  galleryImageUrls: [],
  priceDollars: 4.16,
  description:
    "The Starbucks Dragon 15 Count pack delivers a bold, exotic dragon fruit flavor that instantly transforms any drink into a tropical escape. Known for its vibrant color and refreshing sweetness, this dragon fruit mix brings a smooth, fruity, and invigorating taste that enhances water, lemonade, teas, and DIY Starbucks-inspired beverages.\nPerfect for retailers, cafés, drink creators, and fans of fruity refreshers, this 15-count pack offers convenience, consistency, and a burst of tropical flavor in every serving.\n\nKey Features:\n\n * Exotic dragon fruit flavor for a tropical, refreshing taste \n * 15-count pack ideal for personal use or resale \n * Perfect for enhancing water, lemonade, teas, and custom drinks \n * Adds a sweet, vibrant, and fruity flavor profile \n * Great for Starbucks lovers, drink shops, and on-the-go flavoring ",
  tags: [],
  msrpDollars: 8.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:51.614Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
